<template>
  <section style="padding: 60px 0px">
    <bl-text-av tag="h2" align="center" weight="bold" variation="heading-42" style="margin-bottom: 60px;">
      {{ $options.benefits.title }}
    </bl-text-av>

    <bl-flex-container-mv
      :gutter="24"
      wrap="wrap"
      align-item="center"
      justify-content="center"
      style="max-width: 100%;"
    >
      <bl-flex-item-av v-for="(item, index) in benefitItems" :key="index">
        <article>
          <bl-card-mv class="ph-20 pt-20" style="width: 390px; height: 276px; padding-bottom: 36px;">
            <new-webp-image-container
              :src="item.image"
              :alt="item.title"
              :is-ssr="isSSR"
              styles="width: 64px; height: 64px; margin-bottom: 20px;"
            />
            <bl-text-av tag="h3" weight="semi-bold" style="font-size: 26px; line-height: 32px; margin-bottom: 12px;">
              {{ item.title }}
            </bl-text-av>
            <bl-text-av variation="body-14">
              {{ item.subtitle }}
            </bl-text-av>
          </bl-card-mv>
        </article>
      </bl-flex-item-av>
    </bl-flex-container-mv>
  </section>
</template>

<script>
/* istanbul ignore file */
import { Benefits as benefits } from 'shared/modules/seo/Homepage';
import BlCardMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlCardMv';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';
import BlTextAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlTextAv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexItemAv';

export default {
  name: 'Benefits',

  benefits,

  components: {
    NewWebpImageContainer,
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlCardMv,
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },
    benefitItems() {
      return this.$options.benefits.items;
    },
  },
};
</script>
